import React, { useState } from 'react'
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper,
  TextField,
  Button,
  InputAdornment,
  CircularProgress,
} from '@mui/material'
import { useGetLuckyDrawById } from '../../api/lucky-draw'
import { useSnackbar } from 'notistack'
import RefreshIcon from '@mui/icons-material/Refresh'

const TicketSummaryCard = ({ label, count, color, bgcolor, borderColor }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        textAlign: 'center',
        borderRadius: 1,
        bgcolor,
        border: `1px solid ${borderColor}`,
      }}
    >
      <Typography variant='body2' color='text.secondary' mb={1}>
        {label}
      </Typography>
      <Typography variant='h5' fontWeight={700} color={color}>
        {count}
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        Tickets
      </Typography>
    </Paper>
  )
}

const Page = () => {
  const [companyId, setCompanyId] = useState('')
  const [submittedId, setSubmittedId] = useState(null)
  const { enqueueSnackbar } = useSnackbar()

  const handleError = (error) => {
    enqueueSnackbar('Company not found', { variant: 'error' })
    setSubmittedId(null)
    console.error(error?.response)
  }

  const {
    data = {},
    isLoading,
    refetch,
    isRefetching,
  } = useGetLuckyDrawById(submittedId, {
    enabled: Boolean(submittedId),
    onError: handleError,
  })

  const handleSubmit = () => {
    if (!companyId.trim()) return
    setSubmittedId(companyId.trim())
  }

  return (
    <Box>
      <Box display='flex' justifyContent='center'>
        <img src={'/assets/central-networking-night.png'} width='100%' />
      </Box>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        flexDirection='column'
        textAlign='center'
        my={3}
        p={3}
      >
        <Box mb={3}>
          <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
            Central Networking Night
          </Typography>
          <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
            Lucky Draw Tickets
          </Typography>
        </Box>

        <Card sx={{ p: 2, maxWidth: 400, width: '100%', boxShadow: 4 }}>
          {!submittedId || isLoading ? (
            <CardContent>
              <Typography variant='h5' gutterBottom>
                Enter Company ID
              </Typography>
              <Typography variant='body2' color='text.secondary' gutterBottom>
                Please enter your unique company identifier to proceed.
              </Typography>
              <TextField
                label='Company ID'
                placeholder='e.g. ABC123'
                variant='outlined'
                size='medium'
                value={companyId}
                disabled={isLoading}
                fullWidth
                onChange={(e) => setCompanyId(e.target.value)}
                margin='normal'
                InputProps={{
                  startAdornment: <InputAdornment position='start'>🏢</InputAdornment>,
                }}
              />
              <Button
                variant='contained'
                fullWidth
                size='large'
                sx={{ mt: 2 }}
                onClick={handleSubmit}
                disabled={!companyId.trim() || isLoading}
                startIcon={isLoading && <CircularProgress size='1.5rem' />}
              >
                Submit
              </Button>
            </CardContent>
          ) : (
            <CardContent>
              <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
                {data.companyAccountId}
              </Typography>
              <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
                {data.companyName}
              </Typography>
              <Grid container spacing={2} mt='auto'>
                <Grid item xs={6}>
                  <TicketSummaryCard
                    label='May to Jul 25'
                    count={data.promotion1}
                    color='#1976d2'
                    bgcolor='#e3f2fd'
                    borderColor='#bbdefb'
                  />
                </Grid>
                <Grid item xs={6}>
                  <TicketSummaryCard
                    label='21 Aug 25'
                    count={data.promotion2}
                    color='#388e3c'
                    bgcolor='#e8f5e9'
                    borderColor='#c8e6c9'
                  />
                </Grid>
              </Grid>
              <Box mt={2} display='flex' justifyContent='center'>
                <Button
                  variant='outlined'
                  size='small'
                  startIcon={isRefetching ? <CircularProgress size='1rem' /> : <RefreshIcon />}
                  onClick={refetch}
                  disabled={isRefetching}
                >
                  Refresh
                </Button>
              </Box>
            </CardContent>
          )}
        </Card>
        <Typography variant='caption' color='text.secondary' mt={2}>
          Contact support for any questions
        </Typography>
      </Box>
    </Box>
  )
}

export default Page
